import React, { useState } from 'react';
import { Button, Typography, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { updateUser } from '../../api';
import LoadTextField from '../LoadTextField';


function PasswordForm(props) {
  const account = useSelector(state => state.auth.account);

  const [password, setPassword] = useState({
    first: '',
    second: ''
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (key, val) => {
    setPassword({
      ...password,
      [key]: val
    });
  }

  const handleSubmit = evt => {
    evt.preventDefault();

    if(password.first.length < 5) {
      alert("Password must be at least 5 characters long.");
    } else if(password.first !== password.second) {
      alert("Passwords must match.");
    } else {
      setSaving(true);

      updateUser(account.id, { password: password.first })
        .catch(err => {
          console.warn(err);
          alert('An error occurred.');
        })
        .finally(() => setSaving(false));
    }
  }

  return (
    <>
      <Typography variant='h6'>Password</Typography>

      <form onSubmit={handleSubmit}>
        <LoadTextField
          label='New Password'
          margin='normal'
          autoComplete='new-password'
          variant='outlined'
          type='password'
          value={password.first}
          onChange={evt => handleChange('first', evt.target.value)}
          fullWidth
          required
        />
        <LoadTextField
          label='Confirm New Password'
          margin='normal'
          autoComplete='new-password'
          variant='outlined'
          type='password'
          value={password.second}
          onChange={evt => handleChange('second', evt.target.value)}
          fullWidth
          required
        />

        {saving 
          ? <CircularProgress />
          : <Button
            variant='outlined'
            type='submit'
            >
              Save
            </Button>}
      </form>
    </>
  );
}


export default PasswordForm;
